var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 11.0714H34.8571M13.4286 2.5H30.5714C33.6025 2.5 36.5094 3.70408 38.6527 5.84735C40.7959 7.99062 42 10.8975 42 13.9286V31.0714C42 34.1025 40.7959 37.0094 38.6527 39.1527C36.5094 41.2959 33.6025 42.5 30.5714 42.5H13.4286C10.3975 42.5 7.49062 41.2959 5.34735 39.1527C3.20408 37.0094 2 34.1025 2 31.0714V13.9286C2 10.8975 3.20408 7.99062 5.34735 5.84735C7.49062 3.70408 10.3975 2.5 13.4286 2.5ZM22 31.0714C19.7267 31.0714 17.5465 30.1684 15.9391 28.5609C14.3316 26.9535 13.4286 24.7733 13.4286 22.5C13.4286 20.2267 14.3316 18.0465 15.9391 16.4391C17.5465 14.8316 19.7267 13.9286 22 13.9286C24.2733 13.9286 26.4535 14.8316 28.0609 16.4391C29.6684 18.0465 30.5714 20.2267 30.5714 22.5C30.5714 24.7733 29.6684 26.9535 28.0609 28.5609C26.4535 30.1684 24.2733 31.0714 22 31.0714Z",
    stroke: "#DED2CC",
    strokeWidth: 3.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.3280f6d5630bc4d5bcca2db9636d3d47.svg";
export { ForwardRef as ReactComponent };